import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Link from "@shared/components/contents/link/Link";
const NotFound = () => {
    return (_jsx(Container, { sx: { py: "120px" }, children: _jsxs(Stack, { direction: "column", spacing: 2, sx: {
                alignItems: "center",
                justifyContent: "center",
            }, children: [_jsx(Box, { sx: {
                        textAlign: "center",
                    }, children: _jsx(Typography, { variant: "h1", sx: {
                            color: "primary.dark",
                            fontWeight: "bold",
                            fontSize: { xs: "5rem", md: "8rem" },
                        }, children: "404" }) }), _jsxs(Stack, { spacing: 1, sx: { textAlign: "center" }, children: [_jsx(Typography, { variant: "h2", children: "Page introuvable" }), _jsx(Typography, { variant: "body1", children: "La page que vous cherchez a peut-\u00EAtre \u00E9t\u00E9 d\u00E9plac\u00E9e ou n'existe plus." }), _jsx(Typography, { component: Link, variant: "subtitle1", url: "/", sx: { mt: 1 }, children: "Revenir \u00E0 la page d'accueil" })] })] }) }));
};
export default NotFound;
